import { render, staticRenderFns } from "./newsSidebar.vue?vue&type=template&id=f0a0ae7a&scoped=true"
import script from "./newsSidebar.vue?vue&type=script&lang=js"
export * from "./newsSidebar.vue?vue&type=script&lang=js"
import style0 from "./newsSidebar.vue?vue&type=style&index=0&id=f0a0ae7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a0ae7a",
  null
  
)

export default component.exports